import React, { useRef, useState, useEffect } from "react";
import "../../../../Styles/callletter.css";
import { CommonPageHeading } from "../../../CommonUtilities/CommonHeading/CommonPageHeading";
import { useReactToPrint } from "react-to-print";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { FaEye, FaFilePdf, FaPrint } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonAxiosGet } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { BsInfoCircle } from "react-icons/bs";
import { CURRENT_ACADEMIC_YEAR } from "../../../CommonUtilities/Validations/RegularExpAndVar";

const CertificateInstructions = () => {
    return (
        <div className="instructions-container">
            <h3 className="section-title">Important Information and Instructions:</h3>
            <ol className="instructions-list" start="15">
                <li>
                    Horizontal reservations (for Women, PBD, Meritorious Sports Persons,
                    Ex-Servicemen) will be implemented as per rules in force and relevant
                    Government Orders.
                </li>
                <li>
                    The purpose of this letter is solely to verify the particulars
                    furnished in the online application, which is a pre-requisite for
                    consideration of candidature.{" "}
                    <strong style={{ textDecoration: "underline" }}>
                        Selection will be subject to fulfillment of all prescribed
                        conditions.
                    </strong>
                </li>
                <li>
                    Candidates must produce all requisite original certificates on the{" "}
                    <strong>date at the time of verification</strong> without fail.
                    Failure to attend or produce certificates will result in cancellation
                    of candidature for selection.
                </li>
                <li>
                    Candidates must upload the certificates in his/her
                    <strong> MEGA DSC-{CURRENT_ACADEMIC_YEAR} login</strong> before attending the certificate
                    verification venue.
                </li>
                <li>
                    Candidates must bring all original certificates/documents which are
                    uploaded in the online application along with three sets of xerox
                    copies of the certificates/documents duly attested by a{" "}
                    <strong>Gazetted Officer</strong>.
                </li>
                <li>
                    Candidates should bring five recent passport-size photographs
                    identical to the one uploaded in the online application.
                </li>
            </ol>
            <Row className="note px-3 mt-1 mb-1">
                <Col md={12}>
                    <strong>
                        Note: The mere call letter is only for certificate verification and
                        does not confer any right of selection.
                    </strong>
                </Col>
            </Row>
            <div className="signature-container">
                <div className="signature">
                    <div className="call-letter-sign">
                        <img
                            src="../img/original_sign.jpeg"
                            className="img-fluid"
                            alt="Signature"
                        />
                        <p className="call-letter-text">Convenor, MEGA DSC-{CURRENT_ACADEMIC_YEAR}</p>
                    </div>
                </div>
            </div>


        </div>
    );
};

const CallLetter = (props) => {
    const { callData, navigate, hasResultsAccess } = props;
    return (
        <div className="call-letter-container">
            <div className="call-letter">
                <h5 className="title" style={{ textDecoration: 'underline' }}>
                    MEGA DSC (TEACHER RECRUITMENT TEST) – {CURRENT_ACADEMIC_YEAR}
                    <br />
                    CALL LETTER FOR CERTIFICATE VERIFICATION
                </h5>
                <div className="header-section">
                    <table className="header-table" role="presentation">
                        <tbody>
                            <tr>
                                <td colSpan="2" style={{ paddingBottom: '10px' }}>To</td>
                            </tr>
                            <tr>
                                <td className="header-key">HT No.:</td>
                                <td className="header-value">
                                    {callData?.candidate_id ? (
                                        <strong>{callData?.candidate_id}</strong>
                                    ) : (
                                        "__________________"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Name:</td>
                                <td>
                                    {callData?.applicant_name ? (
                                        <strong>{callData?.applicant_name}</strong>
                                    ) : (
                                        "__________________"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Address:</td>
                                <td>
                                    {callData?.candidate_id ? (
                                        <strong className="address-line">
                                            {`${callData?.address}, ${callData?.village_name}, ${callData?.mandal_name}, ${callData?.dist_name}-${callData?.pin_code}`
                                                .replace(/\s+/g, ' ')
                                                .trim()}
                                        </strong>
                                    ) : (
                                        "__________________"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Contact No.:</td>
                                <td>
                                    {callData?.mobile_no ? (
                                        <strong>{callData?.mobile_no}</strong>
                                    ) : (
                                        "__________________"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Email:</td>
                                <td>
                                    {callData?.email ? (
                                        <strong>{callData?.email}</strong>
                                    ) : (
                                        "__________________"
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p style={{ textAlign: "center" }}>***</p>

                <p>
                    It is hereby informed that Sri / Smt. / Kumari {" "}
                    {callData?.applicant_name ? (
                        <strong>{callData?.applicant_name}</strong>
                    ) : (
                        "__________________"
                    )}
                    , S/o / D/o / W/o Sri{" "}
                    {callData?.father_name ? (
                        <strong>{callData?.father_name}</strong>
                    ) : (
                        "__________________"
                    )}
                    , appeared for Mega DSC – {CURRENT_ACADEMIC_YEAR}, is hereby requested to attend for
                    Certificate Verification in person as per the schedule given below.
                </p>
                <div className="">
                    <div className="venue">
                        <div className="venue-row">
                            <span className="label">Date of certificate verification:</span>
                            <span className="value">
                                {callData?.venue_date ? (
                                    <strong>{callData?.venue_date}</strong>
                                ) : (
                                    "__________________"
                                )}
                            </span>
                        </div>

                        <div className="venue-row">
                            <span className="label">Venue:</span>
                            <span className="value">
                                {callData?.venue ? (
                                    <strong>{callData?.venue} </strong>
                                ) : (
                                    "__________________"
                                )}
                            </span>
                        </div>

                        <div className="venue-row">
                            <span className="label">Time:</span>
                            <span className="value">
                                {callData?.venue_time ? (
                                    <strong>{callData?.venue_time}</strong>
                                ) : (
                                    "__________________"
                                )}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="just-para">
                    <p>
                        Before attending for certificate verification, please upload all
                        relevant certificates/documents at candidate login&nbsp;
                        <button
                            type="button"
                            className="btn btn-link p-0 align-baseline"
                            title="Click to upload documents at apdsc.apcfss.in"
                            onClick={() => {
                                if (hasResultsAccess) {
                                    navigate("/FileUploads");
                                }
                            }}
                        >
                            (apdsc.apcfss.in)
                        </button>
                    </p>

                    <p className="mt-2">
                        Further, it is informed that issuance of{" "}
                        <strong>
                            a call letter for certificate verification does not confer any
                            right to selection
                        </strong>
                        . Attendance at certificate verification is solely for the purpose
                        of confirming the particulars furnished in the online application.
                        The final selection of candidates will be subject to merit,
                        eligibility, reservation, and other prescribed conditions.
                    </p>

                    <p>
                        If the candidate fails to attend certificate verification, or fails
                        to produce the required certificates at the time of verification, or
                        if the certificates are found to be non-genuine or incorrect,&nbsp;
                        <strong>
                            such candidates shall forfeit the right of selection, and the next
                            eligible candidate will be considered for certificate
                            verification.
                        </strong>
                    </p>
                </div>

                <h6 className="call-letter-list">
                    List of Original Documents to be Produced:
                </h6>
                <ol>
                    <li>Printout of the Online Application of Mega DSC–{CURRENT_ACADEMIC_YEAR}.</li>
                    <li>
                        <strong>SSC or its equivalent certificate.</strong>
                    </li>
                    <li>
                        <strong>Intermediate or its equivalent certificate.</strong>
                    </li>
                    <li>
                        Academic qualification certificates{" "}
                        <strong>(Degree Or Post-Graduation)</strong>.
                    </li>
                    <li>
                        Professional qualification certificates{" "}
                        <strong>
                            (D.Ed./Spl.D.Ed/ B.Ed/Spl.B.Ed / UGDPE / B.P.Ed., etc.)
                        </strong>
                        .
                    </li>
                    <li>
                        <strong>TET/CTET Original Score Card/Marks memo</strong>
                    </li>
                    <li>
                        <strong>Study Certificates from Class IV to X (seven years)</strong>{" "}
                        must be submitted. Or Residence certificate for{" "}
                        <strong>07 years prior to appearing in SSC,</strong> if appeared for
                        S.S.C. as a Private Candidate. Candidates who migrated from
                        Telangana to Andhra Pradesh between{" "}
                        <b>
                            2nd June, 2014 and 1st June, 2024 as per G.O. Ms. No. 161, General
                            Administration (SPF&MC) Department, dated.27.12.2022
                        </b>{" "}
                        and as per terms laid down in Circular{" "}
                        <b>Memo No.4136/SPF & MC/2015-5, Dated.20.11.2017</b> and Circular{" "}
                        <b>Memo No.4136/SPF & MC/2015-17, Dated.27.12.2022 </b>of Government
                        of Andhra Pradesh shall obtain the Local Status Certificate from
                        competent authority and produce at the time of verification
                    </li>
                    <li>
                        The rule of reservation to local candidates is applicable as per the
                        provisions of Andhra Pradesh Public Employment (OLC & RDR) Order
                        (Presidential Order)1975, and amendments thereon shall be followed
                        strictly.{" "}
                    </li>
                    <li>
                        <b>Integrated Community Certificate</b> issued by the Tashildhar
                        (for candidates who have claimed reservation under{" "}
                        <b>BC-A,B,C,D & E/SC(Group-I, II & III)/ST categories).</b>
                    </li>
                    <li>
                        <b>EWS Certificate</b> issued by the Tashildhar who claimed
                        reservation under EWS Reservation.{" "}
                    </li>
                    <li>
                        <b>PH Certificate</b> issued by the Referral Hospital (if
                        applicable).{" "}
                    </li>
                    <li>
                        <b>RCI registration</b> Certificate (if applicable).{" "}
                    </li>
                    <li>
                        <b>Service Certificate</b> issued by Competent Authorities of the
                        Department of Defense, GOI if applied under Ex-servicemen Quota.{" "}
                    </li>
                    <li>
                        <b>Experience Certificate</b> (for the post of Principal, if
                        applicable) as per the norms issued in the notification
                    </li>
                </ol>
                <CertificateInstructions />
            </div>
        </div>
    );
};

const DscVerificationCallLetter = () => {
    const componentRef = useRef();
    const loginreducer = useSelector(
        (state) => state.reducers.loginreducer.loginDetails.loginData
    );
    let navigate = useNavigate();
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `CallLetter`,
        pageStyle: `
      @page {
        size: A4;
        margin: 15mm;
      }
      body {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        font-family: 'Times New Roman', serif;
      }
    `,
    });

    const [callData, setCallData] = useState();
    function getDataFunctionResult() {
        const url = `${config.url.DSC_Read_URL}call-letter-details`;
        CommonAxiosGet(url).then((response) => {
            if (response?.data?.status === true) {
                const posts = response?.data?.data[0];
                setCallData(posts);
            } else {
                setCallData();
            }
        });
    }
    useEffect(() => {
        getDataFunctionResult();
    }, []);
    const service = useSelector(
        (state) => state.reducers.loginreducer.loginDetails
    );
    const hasResultsAccess = service?.roleServices?.some(
        (val) => val?.target === "/FileUploads"
    );
    const [showRstatus, setRstatus] = useState(false);
    return (
        <React.Fragment>
            <CommonPageHeading
                heading="MEGA DSC Verification Call Letter"
                drillBack="true"
                handleDrillBack={() => {
                    if (showRstatus === true) {
                        setRstatus(false);
                    } else {
                        navigate(-1);
                    }
                }}
            />
            {showRstatus === false && (
                <Row className="mt-4">
                    <Col md={2}></Col>
                    <Col md={8} className="alert alert-info text-center mt-4">
                        <BsInfoCircle color="skyblue" size="35" />
                        <h5 className="pt-4" style={{ color: "black" }}>
                            {" "}
                            Dear{" "}
                            <span style={{ color: "brown" }}>
                                {" "}
                                {loginreducer?.applicant_name}
                            </span>
                            ,<br />
                            <br />
                            <button
                                type="button"
                                onClick={() => {
                                    setRstatus(true);
                                }}
                                className="btn btn-link btn-sm"
                            >
                                👉 Click here
                            </button>
                            to download MEGA DSC – {CURRENT_ACADEMIC_YEAR} CALL LETTER FOR CERTIFICATE
                            VERIFICATION.
                        </h5>
                        <br />
                        {hasResultsAccess && (
                            <h6>
                                <span className="text-danger">
                                    {" "}
                                    Note : Before attending for certificate verification,please{" "}
                                    <br />
                                    <button
                                        type="button"
                                        onClick={() => {
                                            navigate("/FileUploads");
                                        }}
                                        className="btn btn-link btn-sm"
                                    >
                                        👉 Click here
                                    </button>{" "}
                                    to upload all relevant certificates/documents.
                                </span>
                            </h6>
                        )}
                    </Col>
                    <Col md={2}></Col>{" "}
                </Row>
            )}

            {showRstatus === true && (
                <>
                    {" "}
                    <div className="">
                        <center className="mb-2">
                            <button
                                className="btn btn-secondary rounded-0"
                                variant="primary"
                                type="button"
                                onClick={() => {
                                    handleprint();
                                }}
                            >
                                Print&nbsp;{" "}
                                <FaPrint title="Print" style={{ fontSize: "22px" }} />{" "}
                            </button>
                        </center>
                    </div>
                    <div ref={componentRef}>
                        <CallLetter
                            callData={callData}
                            hasResultsAccess={hasResultsAccess}
                            navigate={navigate}
                        />
                    </div>
                </>
            )}
        </React.Fragment>
    );
};
export default DscVerificationCallLetter;
